import { getEntity, getEntitySubdomain, getNumericalEntityId } from '@opengov/app-core/entity/selectors';
import { modalActionCreators } from '@opengov/component-library-classic/module/modals';
import { getLocation } from '@opengov/compose-app-router/selectors';
import { createSelector, createStructuredSelector } from '@opengov/compose-app/reselect';
import { PATH_TEMPLATE } from '@opengov/stories-shared/constants';

import { storiesMsgs } from '../../locale';

import { selectPublicationId, selectStoryId } from '../../stories/selectors/storyViewSelectors';

import { IStoryGranularAccessProps } from '../components/StoryGranularAccess/StoryGranularAccess';
import { IBulkStoryGranularAccessProps } from '../components/BulkStoryGranularAccess';
import { IPublicationGranularAccessProps } from '../components/PublicationGranularAccess';

export const selectIsTemplate: (state) => boolean = createSelector(getLocation, (location) => {
  const pathArray = location.pathname.split('/');
  const storyPath = pathArray[3];
  return storyPath === PATH_TEMPLATE;
});

export const selectStoryGranularAccessProps = createStructuredSelector<any, IStoryGranularAccessProps>({
  entitySubdomain: createSelector(getEntitySubdomain, (entitySubdomain: string) => entitySubdomain),
  closeModal: () => () => modalActionCreators.resetModalState(),
  storyId: selectStoryId,
  isTemplate: selectIsTemplate,
  entityId: getNumericalEntityId,
  messages: createSelector(storiesMsgs, (msgs) => ({ ...msgs.subjectClaims })),
  publicationId: selectPublicationId
});

export const selectBulkStoryGranularAccessProps = createStructuredSelector<any, Omit<IBulkStoryGranularAccessProps, 'selectedStories'>>({
  entitySubdomain: createSelector(getEntitySubdomain, (entitySubdomain: string) => entitySubdomain),
  closeModal: () => () => modalActionCreators.resetModalState(),
  publicationId: selectPublicationId,
  messages: createSelector(storiesMsgs, (msgs) => ({ ...msgs.subjectClaims }))
});

export const selectPublicationGranularAccessProps = createStructuredSelector<any, IPublicationGranularAccessProps>({
  entitySubdomain: createSelector(getEntitySubdomain, (entitySubdomain: string) => entitySubdomain),
  closeModal: () => () => modalActionCreators.resetModalState(),
  publicationId: selectPublicationId,
  messages: createSelector(storiesMsgs, (msgs) => ({ ...msgs.subjectClaims })),
  entityId: getNumericalEntityId,
  entityUuid: createSelector(getEntity, (entity) => entity.uuid)
});
